import { render, staticRenderFns } from "./ScrollTop.vue?vue&type=template&id=a8c23170&scoped=true"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"
import style0 from "./ScrollTop.vue?vue&type=style&index=0&id=a8c23170&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c23170",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8c23170')) {
      api.createRecord('a8c23170', component.options)
    } else {
      api.reload('a8c23170', component.options)
    }
    module.hot.accept("./ScrollTop.vue?vue&type=template&id=a8c23170&scoped=true", function () {
      api.rerender('a8c23170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScrollTop.vue"
export default component.exports